import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LogoMark } from "./Logo";
import { EASE } from "./motion";
import { AccountButton, CartButton } from "./HeaderActions";
import { scrollToId } from "@/lib/lenis";

const NAV = [
  { id: "ascolta", label: "Ascolta" },
  { id: "musica", label: "Musica & Bio" },
  { id: "sfushop", label: "sfushop" },
  { id: "app", label: "L'app" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menu, setMenu] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setMenu(false);
    scrollToId(id);
  };

  return (
    <motion.header
      initial={{ y: -90 }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay: 1, ease: EASE }}
      className={`fixed inset-x-0 top-0 z-50 border-b backdrop-blur-xl transition-colors duration-500 ${scrolled ? "border-line bg-ink/80" : "border-transparent bg-ink/30"}`}
    >
      <nav className="flex h-16 items-center justify-between px-5 sm:px-8 lg:px-12">
        <button data-testid="navbar-logo" onClick={() => go("home")} className="group flex items-center gap-2.5">
          <LogoMark className="h-8 w-8 transition-transform duration-500 group-hover:rotate-[-12deg]" />
          <span className="font-display text-sm font-black tracking-[0.2em]">SFUMO</span>
        </button>

        <ul className="hidden items-center gap-9 md:flex">
          {NAV.map((l) => (
            <li key={l.id}>
              <button data-testid={`nav-link-${l.id}`} onClick={() => go(l.id)} className="group relative font-mono text-[11px] uppercase tracking-[0.25em] text-bone/80 transition-colors hover:text-bone">
                {l.label}
                <span className="absolute -bottom-1 left-0 h-px w-full origin-right scale-x-0 bg-acid transition-transform duration-500 group-hover:origin-left group-hover:scale-x-100" />
              </button>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <AccountButton />
          <CartButton />
          <button data-testid="mobile-menu-button" onClick={() => setMenu((m) => !m)} aria-label="Menu" className="flex h-10 w-10 items-center justify-center border border-line md:hidden">
            {menu ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {menu && (
          <motion.div initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }} transition={{ duration: 0.5, ease: EASE }} className="overflow-hidden border-t border-line bg-ink md:hidden">
            <ul className="flex flex-col gap-1 px-5 py-6">
              {NAV.map((l) => (
                <li key={l.id}>
                  <button data-testid={`mobile-nav-link-${l.id}`} onClick={() => go(l.id)} className="w-full py-2 text-left font-display text-3xl font-bold uppercase">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
